import api from './api';

export default class CoreApiProvider {
  public static setApiUrl(url: string) {
    api.defaults.baseURL = url;
  }
}
